import React, { useState } from "react";
import { auth, googleProvider, db } from "../services/firebase";
import {
  createUserWithEmailAndPassword,
  signInWithPopup,
  sendEmailVerification,
} from "firebase/auth";
import { ref, set } from "firebase/database";
import { useNavigate } from "react-router-dom";
import { useAlert } from "./AlertContext";
import { FaGoogle } from "react-icons/fa";
import { getRedirectUrl, clearRedirectUrl, validateRedirectUrl } from "../utils/authRedirect";

import "./Login.css";

function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();
    const showAlert = useAlert();
  
  // Check if there's a redirect URL
  const urlParams = new URLSearchParams(window.location.search);
  const redirectUrl = urlParams.get('redirect');

  const registerWithEmail = async () => {
    try {
      const result = await createUserWithEmailAndPassword(auth, email, password);
      const user = result.user;
      await sendEmailVerification(user);
      const userRef = ref(db, "users/" + user.uid);
      await set(userRef, {
        name,
        email,
        username,
        uid: user.uid,
        createdAt: new Date().toISOString(),
      });
      localStorage.setItem("user", JSON.stringify(user));
      showAlert("✅ Registration successful. Please verify your email before logging in. check email in inbox or spam ", "success");
      navigate("/login");
    } catch (err) {
      showAlert("❌ Error: " + err.message, "error");
    }
  };

  const registerWithGoogle = async () => {
    try {
      const result = await signInWithPopup(auth, googleProvider);
      const user = result.user;
      const customUID = "25" + Math.floor(100000000 + Math.random() * 900000000);
      const userRef = ref(db, "users/" + user.uid);
      await set(userRef, {
        name: user.displayName || "",
        email: user.email,
        username: user.email.split("@")[0],
        uid: customUID,
        firebaseUID: user.uid,
        createdAt: new Date().toISOString(),
      });
      localStorage.setItem("user", JSON.stringify(user));
      // Dispatch custom event to notify App.js about user change
      window.dispatchEvent(new Event('userChanged'));
      showAlert("✅ Registered with Google", "success");
      
      // Redirect to intended URL or dashboard
      const redirectUrl = validateRedirectUrl(getRedirectUrl());
      clearRedirectUrl();
      navigate(redirectUrl);
    } catch (err) {
      showAlert("❌ Google registration failed: " + err.message, "error");
    }
  };

  return (
    <div className="login-root">
      <div className="login-left">
        <div className="login-card">
          <div className="login-logo-row">
            <div className="login-logo">BAI</div>
            <span className="login-appname">BodhAI</span>
          </div>
          <h2 className="login-welcome">Create Account</h2>
          <p className="login-subtext">
            {redirectUrl ? "Sign up to access the test" : "Sign up to start your learning journey"}
          </p>
          <div className="login-input-group">
            <input
              type="text"
              placeholder="Full Name"
              value={name}
              onChange={e => setName(e.target.value)}
            />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={e => setEmail(e.target.value)}
            />
            <input
              type="text"
              placeholder="Username"
              value={username}
              onChange={e => setUsername(e.target.value)}
            />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={e => setPassword(e.target.value)}
            />
          </div>
          <button className="login-btn" onClick={registerWithEmail}>Register with Email</button>
          <div className="login-divider">Or continue with</div>
          <div className="login-social-row">
            <button className="login-social-btn" onClick={registerWithGoogle}><FaGoogle/></button>
          </div>
          <div className="login-bottom-row">
            Already have an account? <a href="/login" className="login-link">Login here</a>
          </div>
        </div>
      </div>
      <div className="login-right">
        <div className="login-showcase-card">
          <h2>Elevate Your Skills</h2>
          <p>Join thousands of learners mastering new skills with BodhAI</p>
          <div className="login-stats-row">
            <div className="login-stat">
              <div className="login-stat-value">10K+</div>
              <div className="login-stat-label">Students</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">100+</div>
              <div className="login-stat-label">Test Avaiable</div>
            </div>
            <div className="login-stat">
              <div className="login-stat-value">98%</div>
              <div className="login-stat-label">Satisfaction</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Register;
